<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">积分机制</span>
                <el-row class="cs-filter-row">
                  <el-col :span="6">
                    <el-row>
                      <el-col>
                        <label>积分兑换比例设置</label>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <hr>
                <div
                  class="loading"
                  v-loading="loading"
                >
                  <div class="grid-content">
                    <el-form
                      ref="bonusPointMechanisms"
                      :model="bonusPointMechanisms"
                      :rules="rules"
                      label-width="100px"
                    >
                      <el-row>
                        <el-col :span="6">
                          <el-form-item
                            label="每消费"
                            prop="moneyToBonusPoint.Money"
                          >
                            <el-input
                              :disabled="!USERMANAGER.isAdmin"
                              placeholder="请输入金额"
                              class="input-width"
                              v-model="bonusPointMechanisms.moneyToBonusPoint.Money"
                            >
                              <template slot="append">$</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item
                            label="可获得"
                            prop="moneyToBonusPoint.BonusPoint"
                          >
                            <el-input
                              :disabled="!USERMANAGER.isAdmin"
                              placeholder="请输入积分"
                              class="input-width"
                              v-model="bonusPointMechanisms.moneyToBonusPoint.BonusPoint"
                            >
                              <template slot="append">积分</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="14">
                          <hr>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6">
                          <el-form-item
                            label="每使用"
                            prop="bonusPointToMoney.BonusPoint"
                          >
                            <el-input
                              :disabled="!USERMANAGER.isAdmin"
                              placeholder="请输入积分"
                              class="input-width"
                              v-model="bonusPointMechanisms.bonusPointToMoney.BonusPoint"
                            >
                              <template slot="append">积分</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item
                            label="可抵扣"
                            prop="bonusPointToMoney.Money"
                          >
                            <el-input
                              :disabled="!USERMANAGER.isAdmin"
                              placeholder="请输入金额"
                              class="input-width"
                              v-model="bonusPointMechanisms.bonusPointToMoney.Money"
                            >
                              <template slot="append">$</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="14">
                          <hr>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </div>
                <el-row
                  v-if="USERMANAGER.isAdmin"
                  class="cs-filter-row"
                >
                  <el-col
                    :span="4"
                    class="footer-left"
                  >
                    <el-button
                      size="medium"
                      :disabled="submitBtnDisable"
                      :type="submitBtnClass"
                      @click="saveChanges"
                    >保存更新</el-button>
                  </el-col>
                  <el-col
                    :span="16"
                    class="footer-right"
                  >
                    <el-alert
                      :closable="false"
                      v-show="showError"
                      v-bind:title="errorMessage"
                      type="error"
                      show-icon
                    ></el-alert>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
  }

  .el-input {
    text-align-last: center;
  }
}
</style>

<script>
import navigator from "../../components/navigator";

import {
  getBonusPointMechanismByType,
  saveBonusPointMechanism
} from "../../service/bonusPoint.service";

export default {
  data() {
    let validateMoney = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);

      if (!!value && !isValid) {
        message = "请输入正确的金额";
      }

      if (!message && value == 0) {
        message = "金额不能为0";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateBonusPoint = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);

      if (!!value && !isValid) {
        message = "请输入正确的积分";
      }

      if (!message && value == 0) {
        message = "积分不能为0";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      submitBtnClass: "info",
      submitBtnDisable: true,
      showError: false,
      errorMessage: "",
      bonusPointMechanisms: {
        moneyToBonusPoint: {},
        bonusPointToMoney: {}
      },
      rules: {
        "moneyToBonusPoint.Money": [
          {
            required: true,
            message: "金额不能为空",
            trigger: "blur"
          },
          {
            validator: validateMoney,
            trigger: "blur"
          }
        ],
        "moneyToBonusPoint.BonusPoint": [
          {
            required: true,
            message: "积分不能为空",
            trigger: "blur"
          },
          {
            validator: validateBonusPoint,
            trigger: "blur"
          }
        ],
        "bonusPointToMoney.Money": [
          {
            required: true,
            message: "金额不能为空",
            trigger: "blur"
          },
          {
            validator: validateMoney,
            trigger: "blur"
          }
        ],
        "bonusPointToMoney.BonusPoint": [
          {
            required: true,
            message: "积分不能为空",
            trigger: "blur"
          },
          {
            validator: validateBonusPoint,
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {
    navigator
  },
  computed: {},
  created() {
    this.loadBonusPointMechanisms();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    checkAllInputs() {
      let isValid = true;

      let $ref = this.$refs["bonusPointMechanisms"];
      if (!!$ref) {
        $ref.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    async loadBonusPointMechanisms() {
      let self = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      await getBonusPointMechanismByType(1).then(result => {
        if (!!result && result.success) {
          self.bonusPointMechanisms.moneyToBonusPoint = result.data;
        }
      });

      await getBonusPointMechanismByType(2).then(result => {
        if (!!result && result.success) {
          self.bonusPointMechanisms.bonusPointToMoney = result.data;
        }
      });
      this.loading = false;
    },
    async saveChanges() {
      let self = this;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }

      let cacheSubmitBtnDisable = this.submitBtnDisable;
      this.submitBtnDisable = true;

      let showError = false;
      let errorMessage = "";

      await saveBonusPointMechanism(
        this.bonusPointMechanisms.moneyToBonusPoint
      ).then(result => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.bonusPointMechanisms.moneyToBonusPoint.Id = result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      await saveBonusPointMechanism(
        this.bonusPointMechanisms.bonusPointToMoney
      ).then(result => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.bonusPointMechanisms.bonusPointToMoney.Id = result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      this.$message(`保存更新${!showError ? "成功" : "失败"}`);
      this.showError = showError;
      this.errorMessage = errorMessage;

      this.submitBtnDisable = cacheSubmitBtnDisable;
    }
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/page/admin/bonusPointMechanism.vue